import { render, staticRenderFns } from "./OnlineKefu.vue?vue&type=template&id=167ebbb6&scoped=true"
import script from "./OnlineKefu.vue?vue&type=script&lang=js"
export * from "./OnlineKefu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167ebbb6",
  null
  
)

export default component.exports